export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  {
    question: '深夜爆料的更新频率是怎样的？',
    answer:
      '我们以「爆料流」的形式持续更新，日常每天发布 6 到 12 条，热点集中时单日最高可超过 20 条。晚间 21:00 到次日凌晨 2:00 是更新最密集的时段，也是新料首发的黄金窗口。',
  },
  {
    question: '怎么判断一条爆料是不是第一手？',
    answer:
      '每条内容都会标注发布时间与线索来源类型。凡属本平台首发的内容，均会在标题区显示首发标识，并在正文开头说明信息来源的核实方式。若后续出现新的进展，我们会在原文顶部追加更新，而不是发布新稿覆盖。',
  },
  {
    question: '我想投稿，需要提供哪些信息？',
    answer:
      '投稿时请尽量提供可核查的关键信息，例如时间、地点、涉及方以及你掌握材料的类型。文字描述、截图、公开文件都可以。投稿默认匿名处理，我们不会对外披露线索人身份，也建议你自行对敏感信息做打码处理。',
  },
  {
    question: '投稿之后多久会收到回复？',
    answer:
      '编辑组通常会在 48 小时内完成初步判断。如果线索进入核实流程，我们会通过你留下的联系方式进一步沟通；如果暂时无法核实，线索会保留在待发池中，等后续出现可交叉验证的信息时再启用。',
  },
  {
    question: '内容出现事实错误怎么办？',
    answer:
      '请在「联系我们」页面提交更正说明，并附上可验证的材料。经复核确认有误的，我们会在原文顶部挂出更正说明，说明修改内容与时间，方便读者对照，而不是直接删改旧稿。',
  },
  {
    question: '可以在其他平台转载深夜爆料的内容吗？',
    answer:
      '非商业用途的转载，请保留原文标题与来源标注，并附上原文链接；商业用途或整站抓取请提前联系我们获取授权。我们不接受对原文的断章取义式改写。',
  },
  {
    question: '网站上的内容是付费阅读的吗？',
    answer:
      '深夜爆料的全部内容均可免费阅读，不设置付费墙，也不需要注册即可浏览。我们通过邮件订阅的方式推送首发提醒，订阅完全自愿，随时可以退订。',
  },
  {
    question: '爆料内容会涉及个人隐私吗？',
    answer:
      '我们有一条明确的内容红线：不发布与公共利益无关的私人信息，不公开未涉事未成年人的身份信息。涉及个人隐私的材料即使来源可靠，如果与公共议题无关，也不会被采用。',
  },
];